import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'
import type {
  DrivingTestsHistoryMathsData,
  DrivingTestsHistoryReData,
} from 'teacher-ui-client/components/giraffe/charts/driving-tests/history'

export interface DrivingTestsHistoryReResponse {
  driving_tests_history: {
    students: {
      student_id: number
      completed: number
      total_attempts: number
      content_words: number
      letters_and_sounds: number
      sight_words: number
    }[]
  }[]
}

export async function drivingTestsHistoryRe(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<DrivingTestsHistoryReData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('driving_tests_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<DrivingTestsHistoryReResponse>(url, query)
  if (!data) return null

  const { driving_tests_history } = data
  if (driving_tests_history.length === 0) return null
  if (driving_tests_history[0].students.length === 0) return null

  // Unlike maths, RE DT data does not have driving test grades. Use the first data item (it should be the first and only data item)
  return driving_tests_history[0]
}

export interface DrivingTestsHistoryMsResponse {
  driving_tests_history: {
    driving_test_grade: number
    students: {
      student_id: number
      completed: number
      total_attempts: number
      data: number
      number: number
      operations: number
      geometry: number
      measurement: number
      patterns: number
    }[]
  }[]
}

export async function drivingTestsHistoryMs(
  this: StudentEventsService,
  product: LegacyProductMs,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<DrivingTestsHistoryMathsData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('driving_tests_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<DrivingTestsHistoryMsResponse>(url, query)
  if (!data) return null

  const { driving_tests_history } = data
  if (driving_tests_history.length === 0) return null

  return driving_tests_history
}
